import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
import { useSiteSettings } from '../../contexts/SiteSettingsContext';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { getSetting } = useSiteSettings();
  
  // WhatsApp numarasını ayarlardan al, yoksa varsayılan kullan
  const rawPhone = getSetting('whatsapp', '+905001234567');
  // Telefon numarasından + ve boşlukları temizle
  const phoneNumber = rawPhone.replace(/[\s+\-()]/g, '');
  const defaultMessage = getSetting('whatsapp_message', 'Merhaba, VAV Wear ürünleri hakkında bilgi almak istiyorum.');

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <>
      {/* WhatsApp Button */}
      <motion.div
        className="fixed left-6 bottom-6 z-40"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.5, type: 'spring' }}
      >
        <motion.button
          onClick={() => setIsOpen(!isOpen)}
          className="w-14 h-14 bg-[#25D366] hover:bg-[#20BA5C] rounded-full flex items-center justify-center shadow-lg transition-colors"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          data-testid="whatsapp-btn"
        >
          {isOpen ? (
            <X className="w-6 h-6 text-white" />
          ) : (
            <MessageCircle className="w-6 h-6 text-white" />
          )}
        </motion.button>

        {/* Pulse effect */}
        <motion.div
          className="absolute inset-0 bg-[#25D366] rounded-full -z-10"
          animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0, 0.5] }}
          transition={{ repeat: Infinity, duration: 2 }}
        />
      </motion.div>

      {/* WhatsApp Popup */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed left-6 bottom-24 z-40 w-80"
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
          >
            <div className="bg-vav-bg-paper border border-vav-border rounded-2xl overflow-hidden shadow-xl">
              {/* Header */}
              <div className="bg-[#25D366] p-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <MessageCircle className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="text-white font-medium">VAV Wear Destek</h3>
                    <p className="text-white/80 text-xs">Genellikle hemen yanıt verir</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <div className="bg-vav-bg rounded-lg p-3 mb-4">
                  <p className="text-vav-fg-muted text-sm">
                    Merhaba! 👋 Size nasıl yardımcı olabiliriz? Ürünler, siparişler veya herhangi bir konuda soru sorabilirsiniz.
                  </p>
                </div>

                <button
                  onClick={handleWhatsAppClick}
                  className="w-full py-3 bg-[#25D366] hover:bg-[#20BA5C] text-white rounded-lg font-medium flex items-center justify-center gap-2 transition-colors"
                  data-testid="whatsapp-chat-btn"
                >
                  <MessageCircle className="w-5 h-5" />
                  Sohbete Başla
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default WhatsAppButton;
